import React, { useState, useRef, useEffect, useCallback, useContext } from "react";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import {Form, Card, Row, Col} from "react-bootstrap"
import { Link, useLocation } from 'react-router-dom';

import { editUser, disableUser, enableUser, getUser } from "../../actions/user-action";
import tokenHelper from "../../helpers/tokenHelper";
import { Redirect } from 'react-router-dom';
import ExternalAccountCard from "../../components/ExternalAccountCard/ExternalAccountCard";
import { Shimmer, ShimmerElementsGroup, ShimmerElementType } from '@fluentui/react/lib/Shimmer';
import { Toggle } from '@fluentui/react/lib/Toggle';
import Container from '../../components/ObservableUnits'

import { useGetLegalEntitiesByUserId, useGetBusinessUnitsByUserId, useGetObservableBusinessUnitsByUserId, useGetJobPositionsByUserId, useGetClientProductsToCombobox } from "../../hooks/useOfClient"
import { useGetExternalAccounts, useGetUserPermissionToCombobox } from "../../hooks/useOfProfile"
import { ComboBox, Icon } from '@fluentui/react';
import { MessageBar, MessageBarType } from '@fluentui/react';

import sapFgIntegrationKey from "../../images/sapFieldGlassIntegrationKey.png";
import sg3IntegrationKey from "../../images/sg3IntegrationKey.png"
import nnImg from '../../images/nn.png'
import { useGetProfiles } from "../../hooks/useOfManageUserPermission";
import { PARAM_ADMIN_ROLE, PARAM_EXTERNAL_ROLE, PARAM_OBSERVER_ROLE, PARAM_USER_ROLE } from "../../configurations/staticTypes.config";
import { authGetClient } from "../../actions/auth-action";
import { __AccountType } from "../../common/Dictionaries";
import AuthVerify from "../../components/AuthVerify";
import MainAppContext from "../../MainAppContext";
import { isNullOrUndefined, isNullUndefinedOrEmpty } from "../../common/Helpers";

export default function EditUser() {

  const { t } = useTranslation();

  const { user: currentAuth } = useSelector((state) => state.auth);
  const contextSite = useContext(MainAppContext);

  //const form = useRef();
  const checkBtn = useRef();
  const location = useLocation();
  const userClientId = authGetClient();
  const refProductControl = useRef();

  const username  = location.state !== undefined && location.state.userName !== undefined && location.state !== null && location.state.userName !== null ? location.state.userName : currentAuth.userName;
  const [userId, setUserId] = useState(null);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState(""); 
  const [dnirut, setDniRut] = useState("");
  const [userTypeId, setUserTypeId] = useState(null);
  const [accountType, setaccountType] = useState(null);
  
  const [selectedLegalEntityNemo, setSelectedLegalEntityNemo] = useState("");
  const [selectedLegalEntity, setSelectedLegalEntity] = useState(null);

  const [selectedAreaId, setSelectedAreaId] = useState(null);
  const [selectedAreaNemo, setSelectedAreaNemo] = useState(null);

  const [selectedJobPositionId, setSelectedJobPositionId] = useState(null);
  const [selectedJobPositionNemo, setSelectedJobPositionNemo] = useState(null);

  const [selectedObservableBusinessUnits, setSelectedObservableBusinessUnits] = useState(null);

  const [address, setAddress] = useState("");
  const [selectedLanguages, setSelectedLanguages] = useState([]);

  const [legalEntityList, setLegalEntityList] = useState(null);
  useGetLegalEntitiesByUserId(userId, selectedLegalEntityNemo, setSelectedLegalEntity, legalEntityList, setLegalEntityList, true);

  const [areaList, setAreaList] = useState(null);
  useGetBusinessUnitsByUserId(userId, selectedAreaNemo, setSelectedAreaId, areaList, setAreaList, true);

  const [jobPositionList, setJobPositionList] = useState(null);
  useGetJobPositionsByUserId(userId, selectedJobPositionNemo, setSelectedJobPositionId, jobPositionList, setJobPositionList, true);

  const [observableBusinessUnitList, setObservableBusinessUnitList] = useState(null);
  useGetObservableBusinessUnitsByUserId(!isNullUndefinedOrEmpty(userClientId) && !isNullUndefinedOrEmpty(userId) ? userClientId : null, observableBusinessUnitList, selectedObservableBusinessUnits, setObservableBusinessUnitList);

  // react-dropdown-tree-select no expone el estado "checked" completo del árbol: el
  // selectedNodes que entrega en onChange colapsa cualquier subárbol ya marcado (solo
  // entrega el nodo tope), así que no sirve para reconstruir todas las BU marcadas por
  // cascada. Por eso llevamos nuestro propio set de ids marcados, aplicando las mismas
  // reglas de cascada que usa la librería internamente: al marcar, baja a todos los
  // descendientes; al desmarcar, baja a los descendientes y además sube desmarcando
  // ancestros (porque ya no están "100% marcados"). Se sembra una vez con lo que vino
  // marcado desde el servidor (ver useGetObservableBusinessUnitsByUserId).
  const checkedObservableUnitIdsRef = useRef(new Set());

  useEffect(() => {
      if (observableBusinessUnitList) {
          const initialChecked = new Set();

          const collectChecked = (nodes) => {
              (nodes || []).forEach(node => {
                  if (node.checked) {
                      initialChecked.add(node.id);
                  }

                  collectChecked(node.children);
              });
          };

          collectChecked(observableBusinessUnitList);
          checkedObservableUnitIdsRef.current = initialChecked;
      }
  }, [observableBusinessUnitList]);

  const [userTypeList, setUserTypeList] = useState(null);
  useGetProfiles(userTypeList, setUserTypeList, true)

  const [clientProducts, setClientProducts] = useState(null);
  useGetClientProductsToCombobox(userClientId, clientProducts, setClientProducts)

  const [selectedUserProducts, setSelectedUserProducts] = useState(null);
  useGetUserPermissionToCombobox(username, selectedUserProducts, setSelectedUserProducts, setUserTypeId);

  const options = [
    { key: 'EN', text: t('data-lang-lbl-english') },
    { key: 'ES', text: t('data-lang-lbl-spanish') }
  ];

  const [userpicturefile, setUserpicturefile] = useState();
  const [isLockedOut, setIsLockedOut] = useState(false);
  
  const [isInvalidFirstName, setIsInvalidFirstName] = useState(false);
  const [isInvalidLastName, setIsInvalidLastName] = useState(false);
  const [isInvalidEmail, setIsInvalidEmail] = useState(false);
  const [isInvalidPhoneNumber, setIsInvalidPhoneNumber] = useState(false);
  const [isInvalidLanguage, setIsInvalidLanguage] = useState(false);
  const [isInvalidLegalEntity, setIsInvalidLegalEntity] = useState(false);
  const [isInvalidArea, setIsInvalidArea] = useState(false);
  const [isInvalidAddress, setIsInvalidAddress] = useState(false);
  const [isInvalidJob, setIsInvalidJob] = useState(false);
  const [isInvalidDniRut, setIsInvalidDniRut] = useState(false);
  const [formTwoFactorEnabled, setFormTwoFactorEnabled] = useState(false);
  
  const isInvalidUserType = false;
  const isInvalidBusinessUnit = false;
  
  const [messageErrorFirstName, setMessageErrorFirstName] = useState("");
  const [messageErrorLastName, setMessageErrorLastName] = useState("");
  const [messageErrorEmail, setMessageErrorEmail] = useState("");
  const [messageErrorPhoneNumber, setMessageErrorPhoneNumber] = useState("");
  
  const [isCurrentUser, setIsCurrentUser] = useState(false);

  const [successful, setSuccessful] = useState(null);
  const [loadingEdit, setLoadingEdit] = useState(false);
  const { message } = useSelector(state => state.message);
 
  const [showObservableAreas, setShowObservableAreas] = useState(null)


  const [externalAccounts, setExternalAccounts] = useState(false);
  useGetExternalAccounts(username, setExternalAccounts)

  const dispatch = useDispatch();
  
  const required = (value) => {
    return (!value) ?  t('data-lang-msg-required-field') : "";
  };

  useEffect(()=> {
    if (userId === null) {
      dispatch(getUser(username)).then((response) => {
        let tokenUserName = tokenHelper.GetUserNameTokenData();  
        setContent(response.data, tokenUserName === username);
      }, (error) => {
        const _content =
          (error.response &&
          error.response.data &&
          error.response.data.message) ||
          error.message ||
          error.toString();

        setContent(_content, null);

        if (error.response && error.response.status === 401) {
          //EventBus.dispatch("logout");
        }
      }).catch(() => {
        //Unimplemented.
      });
    }
  }, [userId, dispatch, username]);//quitar dispatch, username si no funciona

  useEffect(()=> {
    if (showObservableAreas === null && userTypeId !== null && legalEntityList !== null && selectedLegalEntityNemo !== null) {
		    setShowObservableAreas((legalEntityList.find(x => x.legal_entity_nemo === selectedLegalEntityNemo).legal_entity_type_id === 1 || legalEntityList.find(x => x.legal_entity_nemo === selectedLegalEntityNemo).legal_entity_type_id === 2))
    }
  }, [showObservableAreas, userId, legalEntityList, selectedLegalEntityNemo, username]);//quitar dispatch, username si no funciona

  const setContent = (_content, _isCurrentUser) => {
    setSelectedObservableBusinessUnits(_content.data.observableBusinessUnitsNemos !== null ? (_content.data.observableBusinessUnitsNemos !== "" ? _content.data.observableBusinessUnitsNemos.split(',') : []) : null);   
    setSelectedAreaNemo(_content.data.businessUnitNemo);
    setEmail(_content.data.email);
    setLastName(_content.data.lastName);
    setFirstName(_content.data.firstName);
    setPhoneNumber(_content.data.phoneNumber);
    setUserpicturefile(_content.data.userpicturefile);
    setDniRut(_content.data.dniRut);
    setaccountType(_content.data.formBasedAuthEnabled === true ? "FBA" : (_content.data.azureActiveDirectoryAuthEnabled === true ? "AAD" : null));
    setFormTwoFactorEnabled(_content.data.formTwoFactorEnabled);
    setSelectedLegalEntityNemo(_content.data.legalEntityNemo);
    setSelectedJobPositionNemo(_content.data.job);
    setUserTypeId(_content.data.userTypeId);

    setAddress(_content.data.address);
    setSelectedLanguages(_content.data.languages !== null && _content.data.languages !== "" ? _content.data.languages.split(',') : []);
    setIsLockedOut(_content.data.isLockedOut);
    

    setUserId(_content.data.id);

    setIsCurrentUser(_isCurrentUser);
  };

  const onChangeFirstname = (e) => {
    const _firstName = e.target.value;
    let errorMessageFirstName = required(_firstName);
    let isEmptyFirstName = errorMessageFirstName === "";

    setMessageErrorFirstName(errorMessageFirstName);
    setIsInvalidFirstName(!isEmptyFirstName);
    setFirstName(_firstName);
  };

  const onChangeLastname = (e) => {
    const _lastName = e.target.value;
    let errorMessageLastName = required(_lastName);
    let isEmptyLastName = errorMessageLastName === "";

    setMessageErrorLastName(errorMessageLastName);
    setIsInvalidLastName(!isEmptyLastName);
    setLastName(_lastName);
  };

  const onChangeLegalEntity = (e) => {
    const legalEntityId = e.target.value;
    let errorMessageLegalEntity = required(legalEntityId === "" || legalEntityId === null || legalEntityId === 0 ? "" : legalEntityId);
    let isEmptyLegalEntity = errorMessageLegalEntity === "";

		setShowObservableAreas((legalEntityList.find(x => x.id === parseInt(legalEntityId)).legal_entity_type_id === 1 || legalEntityList.find(x => x.id === parseInt(legalEntityId)).legal_entity_type_id === 2))

    setIsInvalidLegalEntity(!isEmptyLegalEntity);
    setSelectedLegalEntity(legalEntityList.find(x => x.id === parseInt(legalEntityId)));
  };

  const onChangeArea = (e) => {
    const areaId = e.target.value;
    let errorMessageArea = required(areaId === "" || areaId === null || areaId === 0 ? "" : areaId);
    let isEmptyArea = errorMessageArea === "";

    setIsInvalidArea(!isEmptyArea);
    setSelectedAreaId(areaId);
  };

  const onChangeJob = (e) => {
    const _jobId = e.target.value;
    let errorMessageJob = required(_jobId === "" || _jobId === null || _jobId === 0 ? "" : _jobId);
    let isEmptyJob = errorMessageJob === "";

    setIsInvalidJob(!isEmptyJob);
    setSelectedJobPositionId(_jobId);
  };
  const onChangeAddress = (e) => {
    const _address = e.target.value;
    let errorMessageAddress = required(_address);
    let isEmptyAddress = errorMessageAddress === "";

    setIsInvalidAddress(!isEmptyAddress);
    setAddress(_address);
  };
  const onChangeDnirut = (e) => {
    const _dniRut = e.target.value;
    let errorMessageDniRut = required(_dniRut);
    let isEmptyDniRut = errorMessageDniRut === "";

    setIsInvalidDniRut(!isEmptyDniRut);
    setDniRut(_dniRut);
  };
  
  const onChangeEmail = (e) => {
    const _email = e.target.value;
    let errorMessageEmail = required(_email);
    let isEmptyEmail = errorMessageEmail === "";

    setMessageErrorEmail(errorMessageEmail);
    setIsInvalidEmail(!isEmptyEmail);
    setEmail(_email);
  };

  const onChangeUserType = (e) => {
    if (e.target.value === PARAM_OBSERVER_ROLE) {
			const mainLeId = legalEntityList.reduce((lower, item) => item.id > 0 && item.id < lower ? item.id : lower, Infinity);

      setSelectedLegalEntity(legalEntityList.find(x => x.id === parseInt(mainLeId)));

      setSelectedObservableBusinessUnits(null);
      setFormTwoFactorEnabled(true);
    }
    else {
      if (e.target.value !== PARAM_EXTERNAL_ROLE && e.target.value !== PARAM_USER_ROLE) {
        setFormTwoFactorEnabled(true);
      }
      else {
        setFormTwoFactorEnabled(false);
      }
    }

    setUserTypeId(e.target.value);
  };

  const onTwoFactorChange = (e, checked) => {
    setFormTwoFactorEnabled(checked);
  };

  const onChangeUserProduct = useCallback((event, option, index, value) => {
    let selected = option.selected;

    if (option) {
      setSelectedUserProducts(prevSelected =>
        selected ? [...prevSelected, option.key] : prevSelected.filter(k => k !== option.key),
      );
    }
  },
  [selectedUserProducts],);

  const onChangePhonenumer = (e) => {
    const _phoneNumber = e.target.value;
    let isEmptyPhoneNumber = _phoneNumber === "";
    setMessageErrorPhoneNumber(isEmptyPhoneNumber? t('data-lang-msg-required-field') : "");
    setIsInvalidPhoneNumber(isEmptyPhoneNumber);

    setPhoneNumber(_phoneNumber);
  };
  const onChangeLanguage = useCallback((event, option, index, value) => {
      let selected = option.selected;

      if (option) {
        setSelectedLanguages(prevSelectedLanguages =>
          selected ? [...prevSelectedLanguages, option.key] : prevSelectedLanguages.filter(k => k !== option.key),
        );
      }

      setIsInvalidLanguage((selectedLanguages.length === 0 && !option && !option.selected));
    },
    [selectedLanguages],
  );
  const onChangeUserPicture = (e) => {
    setUserpicturefile(e.target.files[0]);
  };
  /*const onChangeObservableBusinessUnit = (currentNode, selectedNodes) => {
    setSelectedObservableBusinessUnits(selectedNodes.map(item => { return item.nemo }))
  };*/
  const findObservableNodeById = (nodes, id) => {
      for (const node of nodes || []) {
          if (node.id === id) {
              return node;
          }

          const found = findObservableNodeById(node.children, id);
          if (found) {
              return found;
          }
      }

      return null;
  };

  const collectNodeAndDescendantIds = (node, acc) => {
      acc.push(node.id);
      (node.children || []).forEach(child => collectNodeAndDescendantIds(child, acc));
      return acc;
  };

  const findAncestorIds = (nodes, targetId, path) => {
      for (const node of nodes || []) {
          if (node.id === targetId) {
              return path;
          }

          const found = findAncestorIds(node.children, targetId, [...path, node.id]);
          if (found) {
              return found;
          }
      }

      return null;
  };

  const collectNemosFromCheckedIds = (nodes, checkedIds, acc) => {
      (nodes || []).forEach(node => {
          if (checkedIds.has(node.id) && Number(node.typeId) === 2) {
              acc.push(node.nemo);
          }

          collectNemosFromCheckedIds(node.children, checkedIds, acc);
      });

      return acc;
  };

  // Ver el comentario junto a checkedObservableUnitIdsRef: no confiamos en el
  // selectedNodes que entrega la librería (colapsa subárboles ya marcados), solo en
  // currentNode (el nodo realmente togglado) + nuestro propio árbol.
  const onChangeObservableBusinessUnit = (currentNode) => {
      const fullNode = findObservableNodeById(observableBusinessUnitList, currentNode.id);
      if (!fullNode) {
          return;
      }

      const affectedIds = collectNodeAndDescendantIds(fullNode, []);
      const checkedIds = checkedObservableUnitIdsRef.current;

      if (currentNode.checked) {
          affectedIds.forEach(id => checkedIds.add(id));
      }
      else {
          affectedIds.forEach(id => checkedIds.delete(id));

          const ancestorIds = findAncestorIds(observableBusinessUnitList, currentNode.id, []) || [];
          ancestorIds.forEach(id => checkedIds.delete(id));
      }

      setSelectedObservableBusinessUnits(collectNemosFromCheckedIds(observableBusinessUnitList, checkedIds, []));
  };
  const validarFormulario = () => {

    let errorMessageFirstName = required(firstName);
    let isEmptyFirstName = errorMessageFirstName === "";
    setMessageErrorFirstName(errorMessageFirstName);
    setIsInvalidFirstName(!isEmptyFirstName);

    let errorMessageLastName = required(lastName);
    let isEmptyLastName = errorMessageLastName === "";
    setMessageErrorLastName(errorMessageLastName);
    setIsInvalidLastName(!isEmptyLastName);

    let errorMessageEmail = required(email);
    let isEmptyEmail = errorMessageEmail === "";
    setMessageErrorEmail(errorMessageEmail);
    setIsInvalidEmail(!isEmptyEmail);

    let isEmptyPhoneNumber = phoneNumber === "";
    setMessageErrorPhoneNumber(isEmptyPhoneNumber ? t('data-lang-msg-required-field') : "");
    setIsInvalidPhoneNumber(isEmptyPhoneNumber);

    return isEmptyFirstName && isEmptyLastName && isEmptyEmail && !isEmptyPhoneNumber;
  };

  const handleCloseSuccessMessageBar = () => {
    setSuccessful(null);
  }

  const handleEdit = (e) => {
    e.preventDefault();

    if (loadingEdit) {
      return;
    }

    setSuccessful(null);

    if (userId !== null) {

      const estadoFormulario = validarFormulario();

      if (estadoFormulario) {
        const ojbClientFormData = new FormData();
        ojbClientFormData.append('username', username);
        ojbClientFormData.append('id', userId);
        ojbClientFormData.append('email', email);
        ojbClientFormData.append('firstName', firstName);

        ojbClientFormData.append('UserTypeId', userTypeId);
        //[##]Por ahora se envian todos los productos contratados, API asume uno y lo usa de forma transversal. Cambiar cuando se requiera que un usuario cumpla roles distintos en distintos productos.
        //ojbClientFormData.append('Products', userTypeId !== PARAM_USER_ROLE ? clientProducts.map(function(item) { return item.key }) : selectedUserProducts);
        ojbClientFormData.append('Products', clientProducts?.map(function(item) { return item.key })[0]);

        ojbClientFormData.append('job', selectedJobPositionId !== null ?
          (jobPositionList ? (jobPositionList.length > 0 ? jobPositionList.find(element => element.id.toString() === selectedJobPositionId.toString()).job_position_nemo : "") : "") : 
          null
        );

        ojbClientFormData.append('LegalEntityNemo', selectedLegalEntity.id !== null ?
          (legalEntityList ? (legalEntityList.length > 0 ? legalEntityList.find(element => element.id.toString() === selectedLegalEntity.id.toString()).legal_entity_nemo : "") : "") : 
          null
        );

        ojbClientFormData.append('BusinessUnitNemo',  selectedAreaId !== null ?
          (areaList ? (areaList.length > 0 ? areaList.find(element => element.id.toString() === selectedAreaId.toString()).business_unit_nemo : "") : "") :
          null
        );

        ojbClientFormData.append('ObservableBusinessUnitsNemos',  selectedObservableBusinessUnits !== null ?
          (selectedObservableBusinessUnits ? (selectedObservableBusinessUnits.length > 0 ? selectedObservableBusinessUnits.join(",") : null) : null) :
          null
        );

        ojbClientFormData.append('address', address);
        ojbClientFormData.append('dnirut', dnirut);
        ojbClientFormData.append('languages', selectedLanguages);
        ojbClientFormData.append('lastName', lastName);
        ojbClientFormData.append('phoneNumber', phoneNumber);
        //SE COMENTA POR PROBLEMA PENTEST//ojbClientFormData.append('pictureUrl', "");
        //No se envía por que siempre llega null al servicio.
        //En servicio se utiliza Request.Files para obtener el archivo.
        //Si se logra enviar el archivo como parámetro, descomentar y modificar servicio.
        //SE COMENTA POR PROBLEMA PENTEST//ojbClientFormData.append('inputUserPicture ', userpicturefile);

        setLoadingEdit(true);

        dispatch(editUser(ojbClientFormData, isCurrentUser))
          .then((response) => {
            setSuccessful(true);
          })
          .catch(() => {
            setSuccessful(false);
          })
          .finally(() => {
            setLoadingEdit(false);
          });
      }
    }
  };

  const handleEnableDisable = (e, checked) => {
    e.preventDefault();

    setSuccessful(false);

    if (checked === false) {
      dispatch(disableUser(userId)).then(() => {
        setSuccessful(true);
        setIsLockedOut(!isLockedOut);
      }).catch((ex) => {
        setSuccessful(false);
      });
    }
    else {
      dispatch(enableUser(userId)).then(() => {
        setSuccessful(true);
        setIsLockedOut(!isLockedOut);
      }).catch((ex) => {
        setSuccessful(false);
      });
    }

  };

  return (
    <>
      <AuthVerify currentToken={currentAuth} />
      { userId &&
      <Form>
        <Row>
          {successful !== null && (
            <MessageBar
              dismissButtonAriaLabel="Close"
              styles={{root:{marginTop: "-96px !important", display: successful === null ? "none" : "block"}}}
              messageBarType={ successful === true ? MessageBarType.success : MessageBarType.error }
              onDismiss={()=> handleCloseSuccessMessageBar()}>
              {t(message)}
            </MessageBar>
          )}          
          <Col sm={12} md={12} lg={12} xl={12}>
            <Card className="rounded-3">
              <Card.Header>
                <Card.Title style={{ whiteSpace: "nowrap" }}>
                  <h4 style={{float:"left"}}><b>{t('data-lang-pagename-edituser')}</b></h4>
                  <div className='book-toolbar d-flex float-end pt-2'>
                    {!isCurrentUser &&
                      <Toggle
                        checked={!isLockedOut}
                        onChange={handleEnableDisable}
                        role="checkbox"
                        onText={t('data-lang-btn-enable')}
                        offText={t('data-lang-btn-disable')}
                        disabled={loadingEdit}
                        styles={{root:{float: "right", display: "flex"}, label: {marginRight : "5px"}}}
                      />
                    }
                  </div>
                </Card.Title>
              </Card.Header>
              <div className="mx-auto d-block d-sm-block d-md-none d-lg-none pt-4">
                <Row>
                  <Col className="text-center">
                    <img alt="nn1" className="rounded-circle" width={125} src={nnImg}></img>
                  </Col>
                </Row>
                <Row>
                    <Col className="text-center">
                      <Row>
                        <Col>
                          <Icon className="ms-Icon" styles={{root: {fontSize: "26px"}}} iconName={accountType === null || accountType === undefined ? "UserWarning" : (accountType === __AccountType.FBA ? "WebAppBuilderFragment" : "WindowsLogo" )} />
                        </Col>
                      </Row>
                      <Row>
                        <Col style={{fontWeight: "bold"}}>
                          {accountType === null || accountType === undefined? t("data-lang-lbl-unassigned") : (accountType === __AccountType.FBA ? t("data-lang-lbl-fbafull") : t("data-lang-lbl-aadfull") )}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
              </div>
              <div className="card-horizontal">
                <div className="pt-4 d-none d-sm-none d-md-block d-lg-block">  
                  <Row>
                    <Col className="text-center">
                      <img alt="nn2" className="rounded-circle" width={125} src={nnImg}></img>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="text-center">
                      <Row>
                        <Col>
                          <Icon className="ms-Icon" styles={{root: {fontSize: "26px"}}} iconName={accountType === null || accountType === undefined ? "UserWarning" : (accountType === __AccountType.FBA ? "WebAppBuilderFragment" : "WindowsLogo" )} />
                        </Col>
                      </Row>
                      <Row>
                        <Col style={{fontWeight: "bold"}}>
                          {accountType === null || accountType === undefined ? t("data-lang-lbl-unassigned") : (accountType === __AccountType.FBA ? t("data-lang-lbl-fbafull") : t("data-lang-lbl-aadfull") )}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </div>
                <Card.Body className="col-xs-12">
                  <Row>
                    <Col xs={12} sm={12} md={6} lg={6} xl={3}>
                      <Form.Label>{t('data-lang-lbl-username')}</Form.Label>
                      <Form.Control
                        type="text"
                        className="form-control"
                        name="username"
                        value={username || ''}
                        disabled ="disabled "
                      />
                    </Col>
                    <Col xs={12} sm={12} md={6} lg={6} xl={3}>
                      <Form.Label>{t('data-lang-lbl-email')}</Form.Label>
                        {
                          !contextSite.onlyObserver &&
                          <Form.Control
                            type="text"
                            className="form-control"
                            name="email"
                            value={email || ''}
                            disabled={contextSite.onlyObserver}
                            onChange={onChangeEmail}
                            isInvalid={isInvalidEmail}
                            placeholder="example@company.com"
                            autoComplete="off"
                          />
                        }
                        {
                          contextSite.onlyObserver &&
                          <Form.Label className="form-control" style={{backgroundColor: "#e9ecef", height: "30px"}}>{email || ''}</Form.Label>
                        }
                        {
                          isInvalidEmail === true &&
                          <div className="invalid-feedback">
                            {messageErrorEmail}
                          </div>
                        }
                    </Col>
                    {
                        userTypeId !== null &&
                        <>
                            <Col xs={12} sm={12} md={12} lg={6} xl={3}>
                              <Form.Label>{t('data-lang-lbl-usertype')}</Form.Label>
                              {
                                !contextSite.onlyObserver &&
                                <Form.Select
                                  className="form-control"
                                  onChange={onChangeUserType}
                                  value={(userTypeId ? userTypeId : undefined) || null}
                                  disabled={contextSite.onlyObserver}
                                  isInvalid={isInvalidUserType !== null ? isInvalidUserType : false}
                                  >
                                  {
                                    userTypeList ?
                                    
                                      userTypeList.filter(x => (isNullUndefinedOrEmpty(currentAuth.profile.find(x => x === "sAdmin")) && userTypeId !== 'a19028e1-d5a0-4840-b2bc-41cbfc514e1c' ) ? x.name !== "Admin" : true).map((_userType, index) => <option key={index} value={`${_userType.id}`}>{_userType.name}</option>)
                                      : <></>
                                  }
                                </Form.Select>
                              }
                              {
                                contextSite.onlyObserver && userTypeList &&
                                <Form.Label className="form-control" style={{backgroundColor: "#e9ecef", height: "30px"}}>{(userTypeId !== undefined && userTypeId !== null) ? userTypeList.find(x => x.id === userTypeId).name : null}</Form.Label>
                              }
                            </Col>
                            <Col xs={6} sm={6} md={4} lg={12} xl={2} >
                              <Form.Label>{`${ contextSite.onlyObserver ? t('data-lang-lbl-twofactor') : ""}`}</Form.Label>
                              {
                                !contextSite.onlyObserver &&
                                <Toggle
                                  checked={ formTwoFactorEnabled !== null ? formTwoFactorEnabled : false }
                                  onChange={ onTwoFactorChange }
                                  role="checkbox"
                                  label={ t('data-lang-lbl-twofactor') }
                                  disabled={accountType === __AccountType.AAD || contextSite.onlyObserver || (userTypeId !== PARAM_EXTERNAL_ROLE && userTypeId !== PARAM_USER_ROLE)}
                                  onText={ t('data-lang-btn-enabled') }
                                  offText={ t('data-lang-btn-disabled') }
                                  styles={ {root:{float: "right", display: "flex"}, label: {marginRight : "5px"}, container: {paddingTop: "7px"}} }
                                />
                              }
                              {
                                contextSite.onlyObserver &&
                                <Form.Label className="form-control" style={{backgroundColor: "#e9ecef", height: "30px"}}>{`${((formTwoFactorEnabled !== null ? formTwoFactorEnabled : false) ? t('data-lang-lbl-yes') : t('data-lang-lbl-no'))}`}</Form.Label>
                              }
                            </Col>
                            {
                            false &&
                              <Col ref={refProductControl} style={{display: userTypeId !== PARAM_USER_ROLE ? "none" : ""}} xs={12} sm={12} md={12} lg={6} xl={3}>
                                <Form.Label>{t('data-lang-lbl-productasociation')}</Form.Label>
                                <ComboBox
                                  multiSelect
                                  selectedKey={selectedUserProducts}
                                  allowFreeform={false}
                                  options={clientProducts}
                                  onChange={onChangeUserProduct}
                                  required={true}
                                />
                              </Col>
                            }
                          </>
                        }
                  </Row>
                  <Row>
                    <Col xs={12} sm={6} md={6} lg={6} xl={4}>
                        <Form.Label>{t('data-lang-lbl-legalentity')}</Form.Label>
                          {
                          !contextSite.onlyObserver &&
                          <>
                            <Form.Select
                              className="form-control"
                              onChange={onChangeLegalEntity}
                              //disabled={contextSite.onlyObserver}
                              disabled={contextSite.onlyObserver || userTypeId === PARAM_OBSERVER_ROLE}
                              value={(selectedLegalEntity ? selectedLegalEntity.id : undefined) || '0'}
                              isInvalid={isInvalidLegalEntity !== null ? isInvalidLegalEntity : false}
                              >
                              { legalEntityList ? legalEntityList.map((legalEntity, index) => <option key={index} value={legalEntity.id} >{legalEntity.name}</option>) : <></>}
                            </Form.Select>
                            {
                              isInvalidLegalEntity === true &&
                              <div className="invalid-feedback">
                                {t('data-lang-msg-required-field')}
                              </div>
                            }
                          </>
                        }
                        {
                          contextSite.onlyObserver && 
                          <Form.Label className="form-control" style={{backgroundColor: "#e9ecef", height: "30px"}}>{(selectedLegalEntity !== undefined && selectedLegalEntity.id !== null) ? legalEntityList.find(x => x.id === selectedLegalEntity.id).name : null}</Form.Label>
                        }
                    </Col>
                    <Col xs={12} sm={6} md={6} lg={6} xl={4}>
                          <Form.Label>{t('data-lang-lbl-businessunit')}</Form.Label>
                          {
                            !contextSite.onlyObserver &&
                            <>
                              <Form.Select
                                className="form-control"
                                onChange={onChangeArea}
                                disabled={contextSite.onlyObserver}
                                value={(selectedAreaId ? selectedAreaId : undefined) || '0'}
                                isInvalid={isInvalidArea !== null ? isInvalidArea : false}
                                >
                                { areaList ?  areaList.filter(x => x.id === 0 || x.legal_entity_id === (selectedLegalEntity ? parseInt(selectedLegalEntity.id) : null)).map((businessUnit, index) => <option key={index} value={`${businessUnit.id}`}>{businessUnit.name}</option>) : <></> }
                              </Form.Select>
                              {
                                isInvalidArea === true &&
                                <div className="invalid-feedback">
                                  {t('data-lang-msg-required-field')}
                                </div>
                              }
                            </>
                          }
                          {
                            contextSite.onlyObserver &&
                            <Form.Label className="form-control" style={{backgroundColor: "#e9ecef", height: "30px"}}>{(selectedAreaId !== undefined && selectedAreaId !== null && areaList !== null) ? areaList.find(x => x.id === selectedAreaId).name : null}</Form.Label>
                          }
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={12} xl={4}>
                    <Form.Label>{t('data-lang-lbl-job')}</Form.Label>
                        <Form.Select
                          className="form-control"
                          onChange={onChangeJob}
                          value={(selectedJobPositionId ? selectedJobPositionId : undefined) || '0'}
                          isInvalid={isInvalidJob !== null ? isInvalidJob : false}
                          >
                          { jobPositionList ? jobPositionList.map((jobPosition, index) => <option key={index} value={jobPosition.id}>{jobPosition.name}</option>) : <></>}
                        </Form.Select>
                        {
                          isInvalidJob === true &&
                          <div className="invalid-feedback">
                            {t('data-lang-msg-required-field')}
                          </div>
                        }
                    </Col>
                  </Row>
                  {
                    (![PARAM_OBSERVER_ROLE.toLocaleLowerCase(), PARAM_ADMIN_ROLE.toLocaleLowerCase()].includes(userTypeId.toLocaleLowerCase()) &&
                    showObservableAreas) &&
                    <Row style={{padding: "15px 15px 15px 0"}}>
                      <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                        {<Form.Label>{t('data-lang-lbl-observablearea')}</Form.Label>}
                          <Container
                              disabled={
                                  contextSite.onlyObserver &&
                                  !observableBusinessUnitList?.length
                              }
                              data={observableBusinessUnitList ?? []}
                              mode="multiSelect"
                              className="dropdown-checkbox"
                              texts={{
                                  placeholder: t('data-lang-lbl-choose')
                              }}
                              onChange={onChangeObservableBusinessUnit}
                          />
                          {
                            isInvalidBusinessUnit === true &&
                            <div className="invalid-feedback">
                              {t('data-lang-msg-required-field')}
                            </div>
                          }
                        {
                          contextSite.onlyObserver &&
                          <Row className="border">
                            {
                              observableBusinessUnitList && observableBusinessUnitList.filter(x => x.checked !== undefined && x.checked === true).map((x) => 
                                <Col key={x.key}>{x.name}</Col>
                              )
                            }
                          </Row>
                        }
                        {
                          contextSite.onlyObserver && !observableBusinessUnitList &&
                          <Form.Label className="form-control" style={{backgroundColor: "#e9ecef", height: "30px"}}></Form.Label>
                        }
                      </Col>
                    </Row>
                  }
                  <Row>
                    <Col xs={12} sm={6} md={6} lg={6} xl={3}>
                      <Form.Label>{t('data-lang-lbl-firstname')}</Form.Label>
                      <Form.Control 
                        type="text"
                        className="form-control"
                        name="firstname"
                        value={firstName || ''}
                        onChange={onChangeFirstname}
                        isInvalid={isInvalidFirstName}
                        placeholder="Jhon"
                        autoComplete="off"
                      />
                      {
                        isInvalidFirstName === true &&
                        <div className="invalid-feedback">
                          {messageErrorFirstName}
                        </div>
                      }
                    </Col>
                    <Col xs={12} sm={6} md={6} lg={6} xl={3}>
                      <Form.Label>{t('data-lang-lbl-lastname')}</Form.Label>
                      <Form.Control 
                        type="text"
                        className="form-control"
                        name="lastname"
                        value={lastName || ''}
                        onChange={onChangeLastname}
                        isInvalid={isInvalidLastName}
                        placeholder="Doe"
                        autoComplete="off"
                      />
                      {
                        isInvalidLastName === true &&
                        <div className="invalid-feedback">
                          {messageErrorLastName}
                        </div>
                      }
                    </Col>

                    <Col xs={12} sm={6} md={6} lg={6} xl={3}>
                        <Form.Label>{t('data-lang-lbl-dnirut')}</Form.Label>
                        {
                          !contextSite.onlyObserver &&
                          <>
                            <Form.Control
                              type="text"
                              className="form-control"
                              name="dnirut"
                              disabled={contextSite.onlyObserver}
                              value={dnirut || ''}
                              onChange={onChangeDnirut}
                              isInvalid={isInvalidDniRut !== null ? isInvalidDniRut : false}
                              placeholder=""
                              autoComplete="off"
                            />
                            {
                              isInvalidDniRut === true &&
                              <div className="invalid-feedback">
                                {t('data-lang-msg-required-field')}
                              </div>
                            }
                          </>
                        }
                        {
                          contextSite.onlyObserver &&
                          <Form.Label className="form-control" style={{backgroundColor: "#e9ecef", height: "30px"}}>{dnirut || ''}</Form.Label>
                        }
                    </Col>
                    
                    <Col xs={12} sm={6} md={6} lg={6} xl={3}>
                      <Form.Label>{t('data-lang-lbl-phonenumber')}</Form.Label>
                      <Form.Control
                        type="text"
                        className="form-control"
                        name="phonenumber"
                        value={phoneNumber || ''}
                        onChange={onChangePhonenumer}
                        isInvalid={isInvalidPhoneNumber}
                        placeholder="9 12345678"
                        autoComplete="off"
                      />
                      {
                        isInvalidPhoneNumber === true &&
                        <div className="invalid-feedback">
                          { messageErrorPhoneNumber }
                        </div>
                      }
                    </Col>

                  </Row>
                  <Row className="mb-3">
                    <Col xs={12} sm={12} md={6} lg={4} xl={4}>
                        <Form.Label>{t('data-lang-lbl-address')}</Form.Label>
                        <Form.Control
                          type="text"
                          className="form-control"
                          name="address"
                          value={address || ''}
                          onChange={onChangeAddress}
                          isInvalid={isInvalidAddress !== null ? isInvalidAddress : false}
                          placeholder=""
                          autoComplete="off"
                        />
                        {
                          isInvalidAddress === true &&
                          <div className="invalid-feedback">
                            {t('data-lang-msg-required-field')}
                          </div>
                        }
                    </Col>
                    <Col xs={12} sm={12} md={6} lg={4} xl={4}>
                        <Form.Label>{t('data-lang-lbl-languages')}</Form.Label>
                        <ComboBox
                          multiSelect
                          selectedKey={selectedLanguages}
                          allowFreeform={false}
                          options={options}
                          isInvalid={isInvalidLanguage !== null ? isInvalidLanguage : false}
                          onChange={onChangeLanguage}
                          required={true}
                        />
                        {
                          isInvalidLanguage === true &&
                          <div style={{display: "block"}} className="invalid-feedback">
                            {t('data-lang-msg-required-field')}
                          </div>
                        }
                    </Col>
                    {false && <Col xs={12} sm={12} md={6} lg={4} xl={4}>
                      <Form.Label>{t('data-lang-lbl-userpicture')}</Form.Label>
                      <Form.Control
                        type="file"
                        className="form-control"
                        name="inputUserPicture"
                        id="inputUserPicture"
                        onChange={onChangeUserPicture}
                        accept="image/*"
                      />
                    </Col>}
                  </Row>
                </Card.Body>
              </div>
            </Card>
          </Col>
        </Row>
          <Row className="d-md-flex justify-content-md-end">
            <Col xs={12} sm={6} md={4} lg={3} xl={3} xxl={2}>
              <button onClick={handleEdit} data-component-id="btnEdit" type="button" className="btn btn-primary col-12 mt-2" disabled={loadingEdit}>
                { loadingEdit && (<span className="spinner-border spinner-border-sm"></span>) }
                <span> {t('data-lang-btn-edit')} </span>
              </button>
            </Col>
            <Col xs={12} sm={6} md={4} lg={3} xl={3} xxl={2}>
              <Link to="/profile" onClick={(e) => loadingEdit && e.preventDefault()}>
                <button data-component-id="btnGoHome" type="button" className="btn btn-primary col-12 mt-2" disabled={loadingEdit}>{t('data-lang-btn-gohome')}</button>
              </Link>
            </Col>
          </Row>
        <Form.Check style={{ display: "none" }} ref={checkBtn} />
      </Form>
      }
      { !userId &&
        <Shimmer
            customElementsGroup={
              <div>
                <div style={{ display: 'flex' }}>
                    <ShimmerElementsGroup
                        shimmerElements={[
                            { type: ShimmerElementType.circle, height: 125 },
                            { type: ShimmerElementType.gap, width: 16, height: 125 },
                        ]}
                    />
                    <ShimmerElementsGroup
                        flexWrap
                        width="100%"
                        shimmerElements={[
                            { type: ShimmerElementType.line, width: '100%', height: 10, verticalAlign: 'bottom' },
                            { type: ShimmerElementType.line, width: '100%', height: 10 },
                            { type: ShimmerElementType.line, width: '100%', height: 10 },
                            { type: ShimmerElementType.line, width: '100%', height: 10 },
                            { type: ShimmerElementType.gap, width: '100%', height: 25 },
                        ]}
                    />
                </div>
              </div>
            }
            styles={{
                root: {
                    width:"100%",
                    height:"150px",
                    backgroundColor: "white"}
                }
            }
            className="pt-4"
            isDataLoaded={userId !== null}>
        </Shimmer>
      }
    </>
  );
}
